module.exports = __webpack_public_path__ + "static/media/teacher.9481c785.jpg";